import { connect } from 'react-redux'
import actions from 'actions'
import { trackUserAttributes } from 'actions/tracking'
import { actionTypes } from 'actions/actionTypes'
import { getUserId } from 'selectors/user'
import { trackUserLogin } from 'actions/loggingmanager'
import { Page } from './Page'

export const PageContainer = connect((state) => ({
  isAuthenticated: state.auth.get('isAuthenticated'),
  disabled: state.auth.get('isAdmin'),
  email: state.user.get('email'),
  userId: getUserId(state),
  goustoReference: state.user.get('goustoReference'),
  contentFetchPending: state.pending.get(actionTypes.CONTENT_RECEIVE, false),
}), {
  loginVisibilityChange: actions.loginVisibilityChange,
  trackUserAttributes,
  trackUserLogin,
  userLoadData: actions.userLoadData,
})(Page)
